import React from 'react';
import '../template-file-css/document-file-template.css';


export const GENERAL_FollowUpForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_FollowUpForm' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'>
                    <center><h2>FOLLOW-UP</h2> </center>
                </p>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFaceT0Face' name='cbFaceT0Face' className='add-only' value='FaceT0Face' /> FACE TO FACE </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbHome' name='cbHome' className='add-only' value='Home' /> HOME </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOffice' name='cbOffice' className='add-only' value='Office' /> OFFICE </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTelephone' name='cbTelephone' className='add-only' value='Telephone' /> TELEPHONE </td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbFollowUp' name='cbFollowUp' className='add-only' value='EducationalNeeds_9' /> Other:
                            &nbsp;
                            <input type='text' id='txtFollowUpothers' name='txtFollowUpothers' className='add-only w-250 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>FOLLOW-UP CONTACT WITH</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbClient' name='cbClient' className='add-only' value='Client' /> CLIENT </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbParentGuardian' name='cbParentGuardian' className='add-only' value='ParentGuardian' /> PARENT/GUARDIAN</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-280'>
                            <span className='eleHeader'>NAME:</span>
                        </td>
                        <td className='w-187'>
                            <span className='eleHeader'>DOB</span>
                        </td>
                        &nbsp;&nbsp;
                        <td className='w-280'>
                            <span className='eleHeader'>MEDICAID NUMBER:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-280'>
                            <input type='text' id='txtName' name='txtName' className='add-only' />
                        </td>
                        <td className='w-187'>
                            <input type='date' id='txtDateBirth' name='txtDateBirth' className='add-only' />
                        </td>
                        <td className='w-280'>
                            <input type='text' id='txtMedicaidNumber' name='txtMedicaidNumber' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>FOLLOW-UP NUMBER:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbOne' name='cbOne' className='add-only' value='One' /> ONE </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTwo' name='cbTwo' className='add-only' value='Two' /> TWO </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbThree' name='cbThree' className='add-only' value='Three' /> THREE </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFour' name='cbFour' className='add-only' value='Four' /> FOUR </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbFive' name='cbFive' className='add-only' value='Five' /> FIVE </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSix' name='cbSix' className='add-only' value='Six' /> SIX </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbSeven' name='cbSeven' className='add-only' value='Seven' /> SEVEN </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbEight' name='cbEight' className='add-only' value='Eight' /> EIGHT </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbNine' name='cbNine' className='add-only' value='Nine' /> NINE </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbTen' name='cbTen' className='add-only' value='Ten' /> #&nbsp;
                            <input type='text' id='txtTenAdditionalInfo' name='txtTenAdditionalInfo' className='add-only w-50 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>SUMMARY OF FOLLOW-UP CONTACT</span>
                    <span className='small'>(INCLUDE ONLY ONE BILLABLE CONTACT—NON-BILLABLE SERVICES MUST BE DOCUMENTED ON PROGRESS NOTE)</span>
                    <textarea id='txtSummaryOfFollowUp' name='txtSummaryOfFollowUp' className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbDocumentationContinuedOnNextPage' name='cbDocumentationContinuedOnNextPage' className='add-only' value='DocumentationContinuedOnNextPage' />DOCUMENTATION CONTINUED ON NEXT PAGE</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbServicePlanWasReviewedAndUpdated' name='cbServicePlanWasReviewedAndUpdated' className='add-only' value='ServicePlanWasReviewedAndUpdated' />SERVICE PLAN WAS REVIEWED AND UPDATED WITH CLIENT/PARENT/GUARDIAN ACCORDING TO POLICY</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>WERE ADDITIONAL NEEDS IDENTIFIED?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbYesIfYesServicePlan' name='cbYesIfYesServicePlan' className='add-only' value='Yes' /> YES IF YES, SERVICE PLAN ADDENDUM IS NEEDED </td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbNo' name='cbNo' className='add-only' value='No' /> NO </td>

                    </tr>

                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ARE CASE MANAGEMENT SERVICES TO CONTINUE? </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-450'><input type='radio' id='rbYesTimeFrameForNext' name='rbCaseManagement' className='add-only' value='YesTimeFrameForNext' /> YES, TIME FRAME FOR NEXT BILLED FOLLOW-UP VISIT </td>
                        <td className='w-150'> <input type='time' id='txtTime' name='txtTime' className='add-only' /></td>
                        <td className='w-150'> <input type='date' id='txtDate' name='txtDate' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbYesPriorAuthorization' name='rbCaseManagement' className='add-only' value='YesPriorAuthorization' /> YES, PRIOR AUTHORIZATION REQUIRED FOR ADDITIONAL VISITS
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbNoCaseToBeClosed' name='rbCaseManagement' className='add-only' value='NoCaseToBeClosed' /> NO, CASE TO BE CLOSED (COMPLETE CLOSURE FORM)
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-50'></td> <td className='w-700'>
                            <b>  REFERRAL(S) MADE AT TIME OF CLOSURE:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'></td> <td className='w-700'>
                            <input type='checkbox' id='cbNaNoReferralsNeededAtClosure' name='cbNaNoReferralsNeededAtClosure' className='add-only' value='NaNoReferralsNeededAtClosure' /> N/A NO REFERRALS NEEDED AT CLOSURE</td>
                    </tr>
                    <tr>
                        <td className='w-50'></td> <td className='w-700'>
                            <input type='text' id='txtReferralMadeAtTimeOfClosure' name='txtReferralMadeAtTimeOfClosure' className='add-only' /></td>
                    </tr>
                    <tr>
                        <td className='w-700'>
                            <input type='radio' id='NoCaseToBeTransfered' name='rbCaseManagement' className='add-only' value='NoCaseToBeTransfered' /> NO, CASE TO BE TRANSFERRED (COMPLETE TRANSFER FORM)
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> CASE MANAGER SIGNATURE: </td>
                        <td className='small w-375'> Date </td>
                    </tr>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'> CASE MANAGER PRINTED NAME:</td>
                    </tr>
                </table>

            </div>
        </form>

    )
}











